function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { CssContainer } from "../../components/container";
import { PageHeader, Card, Pill, Empty, PlunkDropDown } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import { hasTenantFeature } from "../../functions/tenant-features";
import { num, resolveBusinessModel } from "./territory-common";
import { isAdminUser } from "../stores/common";
import { getSalesTargets, seedSalesTargets, putSalesTargets, downloadSalesTargetsTemplate, salesTargetRows, isSoft, getRepScorecards, getDealerScorecards } from "./sales-api";
import { money, isHouseRep, repName, ShowAll } from "./territory-redesign-kit";
import { Menu } from "../products/px-common";
import { RepSubTop } from "./rep-common";
import { MONTHS, goalMoney, parseAmount, spread, Bars } from "./targets-kit";

/*
 * Sales targets (redesign 2026-10-09, PlunkDocs mockups/sales-forecasts-inventory-redesign-2026-10-09.html,
 * board "4 · Sales targets"). One yearly goal per rep (or dealer); the page spreads it across the months
 * in proportion to that row's sales last year (even split when there were none). "By month" opens the
 * row's 12 month inputs. The save payload is unchanged: monthly cells.
 *
 *   GET  /v1/sales/targets?scope=&from=&to=&ids=      the grid (rows × months)
 *   GET  /v1/sales/targets/seed?scope=&from=&to=&growth=   every empty cell from last year's actual × (1 + growth)
 *   PUT  /v1/sales/targets { scope, targets }          save (403 non-admin, 422 unknown ids)
 *   GET  /v1/sales/targets/template.csv                CSV template with current goals
 *   GET  /v1/sales/scorecards/{reps|dealers}/custom_<year>?sparkline=24
 *        last year's monthly sales (the spread weights + "Sold in <prev>") and this year's sales so far.
 *
 * House accounts (isHouseRep) sit in their own strip, out of the plan total until "Add to plan".
 * Owner and administrator only. Styles: stg-* in sass/v2/_sales-targets.scss.
 */
const CAP = 15;
class SalesTargetsView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "setScope", scope => {
      if (scope === this.state.scope) return;
      this.setState({
        scope,
        q: "",
        showAll: false,
        houseIn: false,
        csvOpen: false,
        addOpen: false
      }, () => {
        this.load(scope);
        try {
          this.props.history.replace({
            pathname: "/Sales/targets",
            search: scope === "rep" ? "" : `?scope=${scope}`
          });
        } catch (e) {/* no router */}
      });
    });
    _defineProperty(this, "setYear", year => {
      this.setState({
        year: Number(year)
      }, () => this.load(this.state.scope, Number(year)));
    });
    // ---- actions ----
    _defineProperty(this, "fill", () => {
      const {
        scope,
        year,
        growth
      } = this.state;
      this.setState({
        busy: true
      });
      seedSalesTargets(scope, `${year}-01`, `${year}-12`, Number(growth) || 0).then(g => {
        if (!this._alive) return;
        if (g === null) {
          this.setState({
            busy: false,
            note: "Filling in goals is not available yet here. Type goals in directly or import a spreadsheet."
          });
          return;
        }
        // Suggested cells arrive suggested=true and saved cells come back as they are. Suggested cells go into the
        // unsaved set (so Save writes them) and stay yellow until edited or saved.
        const dirty = {
          ...this.state.dirty
        };
        const sugg = {
          ...this.state.sugg
        };
        salesTargetRows(g).forEach(row => {
          Object.entries(row.cells || {}).forEach(([period, c]) => {
            if (c && c.suggested && c.revenueGoal != null) {
              const k = this.key(row.scopeId, period);
              dirty[k] = String(c.revenueGoal);
              sugg[k] = true;
            }
          });
        });
        this.setState({
          grid: g || {},
          dirty,
          sugg,
          drafts: {},
          busy: false,
          note: `Goals filled in from ${year - 1} sales plus ${Number(growth) || 0}%. Yellow goals are not saved yet. Change any you like, then Save targets.`
        });
      }).catch(() => this._alive && this.setState({
        busy: false,
        note: "Could not fill in goals. Try again."
      }));
    });
    _defineProperty(this, "save", planRows => {
      const {
        scope
      } = this.state;
      const targets = this.pendingTargets(planRows);
      if (!targets.length) return;
      this.setState({
        busy: true,
        unknown: []
      });
      putSalesTargets(scope, targets).then(r => {
        if (!this._alive) return;
        this.setState({
          busy: false,
          note: `Saved. ${num((r && r.saved) != null ? r.saved : targets.length)} monthly goals updated.`
        });
        this.load(undefined, undefined, undefined, true);
      }).catch(e => {
        if (!this._alive) return;
        if (e && e.status === 403) this.setState({
          busy: false,
          note: "Only workspace owners and administrators can save targets."
        });else if (e && e.status === 422) this.setState({
          busy: false,
          note: "Some rows weren't recognised, so nothing was saved. Remove the marked rows and save again.",
          unknown: (e.data && (e.data.unknownScopeIds || e.data.ids || e.data.unknown) || []).map(String)
        });else if (isSoft(e)) this.setState({
          busy: false,
          note: "Saving targets isn't available yet. Try again later."
        });else this.setState({
          busy: false,
          note: "Save failed. Try again."
        });
      });
    });
    _defineProperty(this, "applyCsv", () => {
      // scope,scopeId,period,revenue_goal[,orders_goal,units_goal]; the 3-column shape scopeId,period,revenue_goal is accepted too. Header row skipped if present.
      const {
        grid,
        csvText,
        scope
      } = this.state;
      const known = new Set(salesTargetRows(grid).map(r => String(r.scopeId)));
      const dirty = {
        ...this.state.dirty
      };
      const sugg = {
        ...this.state.sugg
      };
      let applied = 0;
      let skipped = 0;
      let otherScope = 0;
      csvText.split(/\r?\n/).forEach(line => {
        const parts = line.split(",").map(p => p.trim().replace(/^"|"$/g, ""));
        if (parts.length < 3) return;
        const [a, b, c, d] = parts;
        let scopeId, period, goal;
        if (/^\d{4}-\d{2}$/.test(b)) {
          scopeId = a;
          period = b;
          goal = c;
        } else {
          if (a && a.toLowerCase() !== scope && /^(rep|dealer|territory|store)$/i.test(a)) {
            otherScope++;
            return;
          }
          scopeId = b;
          period = c;
          goal = d;
        }
        if (!/^\d{4}-\d{2}$/.test(period || "") || !Number.isFinite(Number(goal))) {
          if (scopeId && !/scope|period/i.test(line)) skipped++;
          return;
        }
        if (!known.has(scopeId)) {
          skipped++;
          return;
        }
        const k = this.key(scopeId, period);
        dirty[k] = String(Number(goal));
        delete sugg[k];
        applied++;
      });
      this.setState({
        dirty,
        sugg,
        drafts: {},
        csvOpen: false,
        csvText: "",
        note: `${applied} monthly goals filled in from the spreadsheet${skipped ? `. ${skipped} rows skipped (name not on the list or month not YYYY-MM)` : ""}${otherScope ? `. ${otherScope} rows for a different list ignored` : ""}. Check them, then Save targets.`
      });
    });
    // Template: the server's CSV when the route exists; otherwise one row per rep/dealer × month from the loaded grid.
    _defineProperty(this, "downloadTemplate", async () => {
      const {
        grid,
        year,
        scope
      } = this.state;
      try {
        await downloadSalesTargetsTemplate(scope, `${year}-01`, `${year}-12`);
        return;
      } catch (e) {/* fall through to the client template */}
      const rows = salesTargetRows(grid);
      const periods = this.periodsOf();
      let csv = "scope,scopeId,period,revenue_goal\n";
      rows.forEach(r => periods.forEach(p => {
        csv += `${scope},${r.scopeId},${p},${Number(this.valueOf(r, p)) || 0}\n`;
      }));
      const blob = new Blob([csv], {
        type: "text/csv;charset=utf-8"
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `sales-targets-${scope}-${year}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    });
    _defineProperty(this, "onFile", e => {
      const file = e.target.files && e.target.files[0];
      e.target.value = "";
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => this.setState({
        csvText: String(reader.result || "")
      }, this.applyCsv);
      reader.readAsText(file);
    });
    _defineProperty(this, "addDealers", () => {
      const ids = this.state.addIds.split(/[\s,;]+/).map(s => s.trim()).filter(Boolean);
      if (!ids.length) return;
      const current = salesTargetRows(this.state.grid).map(r => r.scopeId);
      this.setState({
        addOpen: false,
        addIds: ""
      });
      this.load(this.state.scope, this.state.year, [...new Set([...current, ...ids])].join(","));
    });
    const y = new Date().getFullYear();
    let _scope = "rep";
    try {
      const q = new URLSearchParams(window.location.search);
      if (q.get("scope") === "dealer") _scope = "dealer";
    } catch (e) {/* no window */}
    this.state = {
      scope: _scope,
      year: y,
      grid: undefined,
      actuals: undefined,
      error: false,
      growth: 8,
      dirty: {},
      sugg: {},
      drafts: {},
      open: {},
      q: "",
      showAll: false,
      houseIn: false,
      busy: false,
      csvOpen: false,
      csvText: "",
      note: null,
      unknown: [],
      businessModel: null,
      addOpen: false,
      addIds: ""
    };
    this._alive = true;
  }
  componentDidMount() {
    resolveBusinessModel().then(bm => {
      if (!this._alive) return;
      if (String(bm || "").toLowerCase() === "retail") {
        this.props.history.replace("/Stores/targets");
        return;
      }
      this.setState({
        businessModel: bm
      });
    }).catch(() => this._alive && this.setState({
      businessModel: "both"
    }));
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  load(scope = this.state.scope, year = this.state.year, ids, keepNote) {
    this.setState(s => ({
      grid: undefined,
      dirty: {},
      sugg: {},
      drafts: {},
      open: {},
      error: false,
      unknown: [],
      note: keepNote ? s.note : null
    }));
    getSalesTargets(scope, `${year}-01`, `${year}-12`, ids).then(g => this._alive && this.setState({
      grid: g === null ? null : g || {}
    })).catch(e => this._alive && this.setState(isSoft(e) ? {
      grid: null
    } : {
      error: true
    }));
    if (!ids) this.loadActuals(scope, year);
  }

  // Last year's months + this year's sales so far, keyed by rep code / dealer id. Optional: the page works without it.
  loadActuals(scope, year) {
    this.setState({
      actuals: undefined
    });
    const range = `custom_${year}0101_${year}1231`;
    const call = scope === "rep" ? getRepScorecards(range, {
      sparkline: 24
    }) : getDealerScorecards(range, {
      sparkline: 24,
      top: 1000
    });
    Promise.resolve(call).then(env => {
      if (!this._alive || this.state.scope !== scope || this.state.year !== year) return;
      if (!env) {
        this.setState({
          actuals: null
        });
        return;
      }
      const map = {};
      const prevYear = String(year - 1);
      (env.items || []).forEach(it => {
        const months = (it.raw && (it.raw.sparklineMonths || it.raw.SparklineMonths) || []).map(String);
        const vals = it.sparkline || [];
        const prev = new Array(12).fill(0);
        if (months.length === vals.length && months.length) {
          months.forEach((m, i) => {
            if (m.slice(0, 4) === prevYear) prev[Number(m.slice(5, 7)) - 1] = Number(vals[i]) || 0;
          });
        } else if (vals.length >= 24) {
          for (let i = 0; i < 12; i++) prev[i] = Number(vals[i]) || 0;
        }
        const rec = {
          prev,
          prevTotal: prev.reduce((a, v) => a + v, 0),
          cur: Number(it.revenue) || 0
        };
        [it.id, it.repCode, it.customerId, it.accountNumber].filter(Boolean).forEach(k => {
          map[String(k)] = rec;
        });
      });
      this.setState({
        actuals: map
      });
    }).catch(() => this._alive && this.setState({
      actuals: null
    }));
  }
  // ---- cells ----
  periodsOf() {
    const g = this.state.grid;
    const p = g && g.periods || [];
    if (p.length) return p;
    return MONTHS.map((m, i) => `${this.state.year}-${String(i + 1).padStart(2, "0")}`);
  }
  key(id, period) {
    return `${id}|${period}`;
  }
  valueOf(row, period) {
    const k = this.key(row.scopeId, period);
    if (k in this.state.dirty) return this.state.dirty[k];
    const c = (row.cells || {})[period];
    return c && c.revenueGoal != null ? String(c.revenueGoal) : "";
  }
  isSuggested(row, period) {
    const k = this.key(row.scopeId, period);
    if (k in this.state.dirty) return !!this.state.sugg[k];
    const c = (row.cells || {})[period];
    return !!(c && c.suggested);
  }
  rowMonths(row) {
    return this.periodsOf().map(p => Number(this.valueOf(row, p)) || 0);
  }
  rowTotal(row) {
    return this.rowMonths(row).reduce((a, v) => a + v, 0);
  }
  rowSuggested(row) {
    return this.periodsOf().some(p => this.isSuggested(row, p));
  }
  rowHasSaved(row) {
    return Object.values(row.cells || {}).some(c => c && !c.suggested && Number(c.revenueGoal) > 0);
  }
  actualOf(row) {
    const a = this.state.actuals;
    return a && a[String(row.scopeId)] || null;
  }
  lastYearOf(row) {
    if (row.lastYear != null && Number(row.lastYear) > 0) return Number(row.lastYear);
    const a = this.actualOf(row);
    return a ? a.prevTotal : row.lastYear != null ? Number(row.lastYear) : null;
  }
  // Spread weights: last year's months; else the row's current months (e.g. filled-in goals); else an even split.
  weightsOf(row) {
    const a = this.actualOf(row);
    if (a && a.prevTotal > 0) return a.prev;
    const cur = this.rowMonths(row);
    return cur.some(v => v > 0) ? cur : new Array(cur.length || 12).fill(1);
  }
  editMonth(row, period, v) {
    const clean = String(v).replace(/[^0-9.]/g, "");
    const k = this.key(row.scopeId, period);
    this.setState(s => {
      const sugg = {
        ...s.sugg
      };
      delete sugg[k];
      return {
        dirty: {
          ...s.dirty,
          [k]: clean
        },
        sugg
      };
    });
  }
  editYear(row, text) {
    const id = row.scopeId;
    const periods = this.periodsOf();
    const amt = parseAmount(text);
    this.setState(s => {
      const dirty = {
        ...s.dirty
      };
      const sugg = {
        ...s.sugg
      };
      if (amt != null) {
        // Weights are taken when the field gets focus, so each keystroke spreads the same way.
        const w = this._weights && this._weights[id] || this.weightsOf(row);
        const parts = spread(amt, w.slice(0, periods.length));
        periods.forEach((p, i) => {
          const k = this.key(id, p);
          dirty[k] = String(parts[i]);
          delete sugg[k];
        });
      } else if (!String(text).trim()) {
        periods.forEach(p => {
          const k = this.key(id, p);
          dirty[k] = "";
          delete sugg[k];
        });
      }
      return {
        dirty,
        sugg,
        drafts: {
          ...s.drafts,
          [id]: text
        }
      };
    });
  }
  focusYear(row) {
    this._weights = {
      ...(this._weights || {}),
      [row.scopeId]: this.weightsOf(row)
    };
    const t = this.rowTotal(row);
    this.setState(s => ({
      drafts: {
        ...s.drafts,
        [row.scopeId]: t ? String(Math.round(t)) : ""
      }
    }));
  }
  blurYear(row) {
    if (this._weights) delete this._weights[row.scopeId];
    this.setState(s => {
      const d = {
        ...s.drafts
      };
      delete d[row.scopeId];
      return {
        drafts: d
      };
    });
  }
  // Unsaved cells that would be written: house rows only when they're part of the plan.
  pendingTargets(rows) {
    const {
      dirty
    } = this.state;
    const inPlan = new Set(rows.map(r => String(r.scopeId)));
    return Object.entries(dirty).filter(([k, v]) => String(v).trim() !== "" && Number.isFinite(Number(v)) && inPlan.has(k.slice(0, k.lastIndexOf("|")))).map(([k, v]) => {
      const i = k.lastIndexOf("|");
      return {
        scopeId: k.slice(0, i),
        period: k.slice(i + 1),
        revenueGoal: Number(v)
      };
    });
  }
  toggleOpen(id) {
    this.setState(s => {
      const open = {
        ...s.open
      };
      if (open[id]) delete open[id];else open[id] = true;
      return {
        open
      };
    });
  }

  // ---- render ----
  header(planRows) {
    const {
      scope,
      year,
      busy,
      businessModel
    } = this.state;
    const thisYear = new Date().getFullYear();
    const years = [thisYear - 1, thisYear, thisYear + 1];
    if (!years.includes(year)) years.push(year);
    const pending = planRows ? this.pendingTargets(planRows).length : 0;
    const menu = [{
      key: "csv",
      label: "Import CSV",
      onClick: () => this.setState({
        csvOpen: true,
        addOpen: false
      })
    }, {
      key: "tpl",
      label: "Download template",
      onClick: this.downloadTemplate
    }, scope === "dealer" ? {
      key: "add",
      label: "Add dealers",
      onClick: () => this.setState({
        addOpen: true,
        csvOpen: false
      })
    } : null, hasTenantFeature("storePerformance") && businessModel !== "manufacturing" ? {
      key: "stores",
      label: "Store targets",
      onClick: () => this.props.history.push("/Stores/targets")
    } : null];
    return (
      /*#__PURE__*/
      // Composer sub-page format (outside the cockpit tabs): back button, crumbs, title, meta, controls.
      React.createElement(RepSubTop, {
        crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
          to: "/Sales/this_year"
        }, "Sales"), " \xB7 Targets"),
        title: `Sales targets for ${year}`,
        meta: scope === "rep" ? "Set a yearly goal for each rep. We spread it across the months the way last year's sales fell." : "Set a yearly goal for each dealer. We spread it across the months the way last year's sales fell.",
        onBack: () => this.props.history.push("/Sales/this_year")
      }, /*#__PURE__*/React.createElement("span", {
        className: "stg-seg",
        role: "group",
        "aria-label": "Goals for"
      }, [["rep", "Reps"], ["dealer", "Dealers"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
        key: k,
        type: "button",
        className: scope === k ? "on" : "",
        onClick: () => this.setScope(k)
      }, l))), /*#__PURE__*/React.createElement("span", {
        className: "stg-year"
      }, /*#__PURE__*/React.createElement(PlunkDropDown, {
        width: "110px",
        value: year,
        onChange: this.setYear,
        options: years.sort().map(y => [y, String(y)])
      })), /*#__PURE__*/React.createElement(Menu, {
        label: "More",
        items: menu,
        triggerCls: "stg-more"
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "stg-btn primary",
        disabled: busy || !pending,
        onClick: () => this.save(planRows || [])
      }, "Save targets"))
    );
  }
  renderPanels(rows) {
    const {
      scope,
      year,
      csvOpen,
      csvText,
      addOpen,
      addIds,
      note
    } = this.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, note ? /*#__PURE__*/React.createElement("div", {
      className: "stg-note"
    }, note, /*#__PURE__*/React.createElement("a", {
      className: "stg-x",
      href: "#",
      "aria-label": "Dismiss",
      onClick: e => {
        e.preventDefault();
        this.setState({
          note: null
        });
      }
    }, "\xD7")) : null, addOpen && /*#__PURE__*/React.createElement("section", {
      className: "stg-panel"
    }, /*#__PURE__*/React.createElement("b", null, "Add dealers"), /*#__PURE__*/React.createElement("input", {
      className: "stg-text",
      value: addIds,
      placeholder: "Dealer account numbers, separated by commas",
      onChange: e => this.setState({
        addIds: e.target.value
      })
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "stg-btn",
      onClick: this.addDealers
    }, "Add to list"), /*#__PURE__*/React.createElement("a", {
      className: "stg-textlink",
      href: "#",
      onClick: e => {
        e.preventDefault();
        this.setState({
          addOpen: false
        });
      }
    }, "Cancel"), /*#__PURE__*/React.createElement("span", {
      className: "stg-muted stg-full"
    }, "The list starts with your top 50 dealers by last year's sales. Add any other account here.")), csvOpen && /*#__PURE__*/React.createElement("section", {
      className: "stg-panel"
    }, /*#__PURE__*/React.createElement("b", null, "Import goals from a spreadsheet"), /*#__PURE__*/React.createElement("label", {
      className: "stg-btn stg-file"
    }, "Choose CSV file", /*#__PURE__*/React.createElement("input", {
      type: "file",
      accept: ".csv,text/csv",
      onChange: this.onFile
    })), /*#__PURE__*/React.createElement("span", {
      className: "stg-muted"
    }, "Columns: scope, id, month (YYYY-MM), goal. Download the template from the \xB7\xB7\xB7 menu to start from your current goals, or paste rows below."), /*#__PURE__*/React.createElement("textarea", {
      className: "stg-csv",
      rows: 5,
      placeholder: `scope,scopeId,period,revenue_goal\n${scope},${rows[0] ? rows[0].scopeId : "WHIT-FL"},${year}-01,25000`,
      value: csvText,
      onChange: e => this.setState({
        csvText: e.target.value
      })
    }), /*#__PURE__*/React.createElement("span", {
      className: "stg-row"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "stg-btn",
      disabled: !csvText.trim(),
      onClick: this.applyCsv
    }, "Fill in from these rows"), /*#__PURE__*/React.createElement("a", {
      className: "stg-textlink",
      href: "#",
      onClick: e => {
        e.preventDefault();
        this.setState({
          csvOpen: false,
          csvText: ""
        });
      }
    }, "Cancel"))));
  }
  render() {
    if (!hasTenantFeature("salesTransactions") && !hasTenantFeature("territoryRep")) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Sales targets are not set up for this workspace."));
    }
    if (!isAdminUser()) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Sales targets are available to workspace owners and administrators."));
    }
    const {
      grid,
      error,
      year,
      growth,
      busy,
      scope,
      unknown,
      q,
      showAll,
      houseIn,
      open,
      drafts,
      actuals
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    const wrap = "territory-view ec-view ecc-view trr-view stores-view sales-view tr-view wa-view stg-view";
    if (grid === undefined) return /*#__PURE__*/React.createElement("div", {
      className: wrap
    }, this.header(null), /*#__PURE__*/React.createElement("div", {
      className: "trr-body"
    }, /*#__PURE__*/React.createElement(Loader, null)));
    if (grid === null) {
      return /*#__PURE__*/React.createElement("div", {
        className: wrap
      }, this.header(null), /*#__PURE__*/React.createElement("div", {
        className: "trr-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "wa-grid"
      }, /*#__PURE__*/React.createElement(Card, {
        title: "Goals"
      }, /*#__PURE__*/React.createElement(Empty, null, "Targets couldn't be loaded right now. ", /*#__PURE__*/React.createElement("a", {
        className: "tr-link",
        href: "#",
        onClick: e => {
          e.preventDefault();
          this.load();
        }
      }, "Try again"), ". If it keeps happening, contact support.")))));
    }
    const thisYear = new Date().getFullYear();
    const prev = year - 1;
    const who = scope === "rep" ? "rep" : "dealer";
    const periods = this.periodsOf();
    const all = salesTargetRows(grid).map(r => ({
      ...r,
      display: scope === "rep" ? repName({
        name: r.name,
        repCode: r.scopeId
      }) : r.name
    }));
    const isHouse = r => isHouseRep({
      name: r.name,
      repCode: r.scopeId
    });
    const house = all.filter(isHouse);
    const houseInPlan = house.filter(r => houseIn || this.rowHasSaved(r));
    const houseOut = house.filter(r => !houseInPlan.includes(r));
    const planRows = all.filter(r => !isHouse(r)).concat(houseInPlan).map(r => ({
      ...r,
      ly: this.lastYearOf(r)
    })).sort((a, b) => (Number(b.ly) || 0) - (Number(a.ly) || 0) || String(a.display).localeCompare(String(b.display)));
    const planTotal = planRows.reduce((a, r) => a + this.rowTotal(r), 0);
    const prevTotal = planRows.reduce((a, r) => a + (Number(r.ly) || 0), 0);
    const ql = q.trim().toLowerCase();
    const shown = ql ? planRows.filter(r => `${r.display} ${r.name} ${r.scopeId} ${r.sub || ""}`.toLowerCase().includes(ql)) : planRows;
    const visible = showAll || ql ? shown : shown.slice(0, CAP);
    const unknownSet = new Set(unknown);
    const soldLabel = year < thisYear ? `Sold in ${year}` : "Sold so far";
    const anyGoal = planTotal > 0;
    return /*#__PURE__*/React.createElement("div", {
      className: wrap
    }, this.header(planRows), /*#__PURE__*/React.createElement("div", {
      className: "trr-body"
    }, this.renderPanels(all), /*#__PURE__*/React.createElement("section", {
      className: "stg-start"
    }, /*#__PURE__*/React.createElement("b", {
      className: "stg-h"
    }, "Start from last year"), /*#__PURE__*/React.createElement("span", {
      className: "stg-copy"
    }, "Grow every ", who, "'s ", prev, " sales by"), /*#__PURE__*/React.createElement("span", {
      className: "stg-pct"
    }, /*#__PURE__*/React.createElement("input", {
      type: "number",
      value: growth,
      min: -50,
      max: 200,
      step: 1,
      "aria-label": "Growth percent",
      onChange: e => this.setState({
        growth: e.target.value
      })
    }), /*#__PURE__*/React.createElement("span", null, "%")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "stg-btn",
      disabled: busy,
      onClick: this.fill
    }, "Fill in goals"), /*#__PURE__*/React.createElement("span", {
      className: "stg-fill"
    }), /*#__PURE__*/React.createElement("span", {
      className: "stg-total"
    }, /*#__PURE__*/React.createElement("span", {
      className: "stg-muted"
    }, "Plan total"), /*#__PURE__*/React.createElement("b", null, anyGoal ? goalMoney(planTotal) : "$0"), prevTotal > 0 ? /*#__PURE__*/React.createElement("span", {
      className: "stg-muted stg-small"
    }, "vs ", goalMoney(prevTotal), " sold in ", prev) : null)), /*#__PURE__*/React.createElement("section", {
      className: "stg-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "stg-card-h"
    }, /*#__PURE__*/React.createElement("b", {
      className: "stg-h"
    }, "Goals by ", who), /*#__PURE__*/React.createElement("span", {
      className: "stg-muted stg-small"
    }, "type a yearly number, or open a ", who, " to adjust single months"), /*#__PURE__*/React.createElement("span", {
      className: "stg-fill"
    }), /*#__PURE__*/React.createElement("input", {
      className: "stg-search",
      type: "search",
      value: q,
      placeholder: scope === "rep" ? "Search reps" : "Search dealers",
      onChange: e => this.setState({
        q: e.target.value
      })
    })), planRows.length ? /*#__PURE__*/React.createElement("div", {
      className: "stg-scroll"
    }, /*#__PURE__*/React.createElement("table", {
      className: "stg-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, scope === "rep" ? "Rep" : "Dealer"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Sold in ", prev), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, year, " goal"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, soldLabel), /*#__PURE__*/React.createElement("th", null, "Monthly spread"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, visible.map(r => {
      const id = r.scopeId;
      const total = this.rowTotal(r);
      const months = this.rowMonths(r);
      const act = this.actualOf(r);
      const sug = this.rowSuggested(r);
      const isOpen = !!open[id];
      const draft = id in drafts ? drafts[id] : null;
      const cur = year > thisYear ? null : act ? act.cur : actuals === undefined ? undefined : null;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: id
      }, /*#__PURE__*/React.createElement("tr", {
        className: `${isOpen ? "open" : ""}${unknownSet.has(String(id)) ? " bad" : ""}`
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "stg-name"
      }, r.display), /*#__PURE__*/React.createElement("span", {
        className: "stg-code"
      }, r.sub && r.sub !== r.name ? r.sub : scope === "dealer" ? id : "", isHouse(r) ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement(Pill, {
        tone: "neutral"
      }, "house account")) : null, r.bookChanged ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("span", {
        title: "This rep's accounts changed by more than 10% since the goal was set"
      }, /*#__PURE__*/React.createElement(Pill, {
        tone: "warning"
      }, "accounts changed"))) : null, unknownSet.has(String(id)) ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement(Pill, {
        tone: "danger"
      }, "not recognised")) : null)), /*#__PURE__*/React.createElement("td", {
        className: "n stg-muted"
      }, r.ly ? money(r.ly) : "none"), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, /*#__PURE__*/React.createElement("input", {
        className: `stg-goal${sug ? " sug" : ""}`,
        inputMode: "decimal",
        "aria-label": `${year} goal for ${r.display}`,
        value: draft != null ? draft : total ? goalMoney(total) : "",
        placeholder: "$0",
        onFocus: () => this.focusYear(r),
        onBlur: () => this.blurYear(r),
        onChange: e => this.editYear(r, e.target.value)
      })), /*#__PURE__*/React.createElement("td", {
        className: "n stg-muted"
      }, cur === undefined ? "…" : cur == null ? "-" : money(cur)), /*#__PURE__*/React.createElement("td", null, total ? /*#__PURE__*/React.createElement(Bars, {
        values: months
      }) : /*#__PURE__*/React.createElement(Bars, {
        values: act ? act.prev : [],
        muted: true
      })), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, /*#__PURE__*/React.createElement("a", {
        className: "stg-link",
        href: "#",
        "aria-expanded": isOpen,
        onClick: e => {
          e.preventDefault();
          this.toggleOpen(id);
        }
      }, isOpen ? "Close" : "By month"))), isOpen ? /*#__PURE__*/React.createElement("tr", {
        className: "stg-months-row"
      }, /*#__PURE__*/React.createElement("td", {
        colSpan: 6
      }, /*#__PURE__*/React.createElement("div", {
        className: "stg-months"
      }, periods.map((p, i) => {
        const k = this.key(id, p);
        return /*#__PURE__*/React.createElement("label", {
          key: p,
          className: "stg-month"
        }, /*#__PURE__*/React.createElement("span", {
          className: "m"
        }, MONTHS[Number(p.slice(5)) - 1] || p), /*#__PURE__*/React.createElement("input", {
          className: `stg-cell${this.isSuggested(r, p) ? " sug" : k in this.state.dirty ? " edited" : ""}`,
          inputMode: "decimal",
          value: this.valueOf(r, p),
          onChange: e => this.editMonth(r, p, e.target.value)
        }), /*#__PURE__*/React.createElement("span", {
          className: "ly"
        }, act && act.prev[i] ? `${money(act.prev[i])} in ${prev}` : `none in ${prev}`));
      })), /*#__PURE__*/React.createElement("p", {
        className: "stg-muted stg-small stg-month-note"
      }, "Changing a month changes the ", year, " goal. Typing a new yearly goal spreads it again across the months."))) : null);
    }), !visible.length ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: 6,
      className: "stg-muted"
    }, "No ", who, "s match \"", q, "\".")) : null))) : /*#__PURE__*/React.createElement("p", {
      className: "stg-muted stg-pad"
    }, scope === "rep" ? "No reps on the list yet. Reps arrive with your sales rep data." : "No dealers on the list yet. Dealers arrive with your wholesale sales data."), /*#__PURE__*/React.createElement(ShowAll, {
      total: ql ? 0 : shown.length,
      shown: CAP,
      open: showAll && !ql,
      onToggle: () => this.setState({
        showAll: !showAll
      }),
      allLabel: `Show all ${shown.length} ${who}s`,
      note: `Yellow = a suggested goal you haven't saved yet.${house.length ? " House accounts are listed separately below and left out of the plan total unless you add them." : ""}`
    })), house.length ? /*#__PURE__*/React.createElement("section", {
      className: "stg-house"
    }, /*#__PURE__*/React.createElement("b", null, "House accounts"), /*#__PURE__*/React.createElement("span", {
      className: "stg-muted stg-house-list"
    }, (houseOut.length ? houseOut : houseInPlan).map(r => {
      const ly = this.lastYearOf(r);
      return ly ? `${r.display} ${money(ly)} in ${prev}` : r.display;
    }).join(" · ")), /*#__PURE__*/React.createElement("span", {
      className: "stg-fill"
    }), houseOut.length ? /*#__PURE__*/React.createElement("a", {
      className: "stg-link",
      href: "#",
      onClick: e => {
        e.preventDefault();
        this.setState({
          houseIn: true
        });
      }
    }, "Add to plan") : houseIn ? /*#__PURE__*/React.createElement("a", {
      className: "stg-link",
      href: "#",
      onClick: e => {
        e.preventDefault();
        this.setState({
          houseIn: false
        });
      }
    }, "Leave out of plan") : /*#__PURE__*/React.createElement("span", {
      className: "stg-muted stg-small"
    }, "In the plan (they already have saved goals)")) : null));
  }
}
export default withRouter(SalesTargetsView);